import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetPatientTherapySequence(sequenceId: string | undefined) {
  return useQuery(queries.patientsTherapies.getSequenceById(sequenceId || ''))
}
